import AOS from 'aos';
// import 'aos/dist/aos.css';

import EmblaCarousel from 'embla-carousel';
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'
import { addPrevNextBtnsClickHandlers } from './plugins/EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from './plugins/EmblaCarouselDotButton';
import Mark from 'mark.js/dist/mark.es6.min.js';

import 'bootstrap/dist/js/bootstrap.bundle.js';

AOS.init({
  duration: 1000,
  once: true
});

(function () {

  var sentinels = document.querySelectorAll('.sticky-sentinel');
  if (!sentinels.length) return;

  var body = document.body;
  var ticking = false;

  function checkStickyState() {

    var anyStickyActive = false;

    Array.prototype.forEach.call(sentinels, function (sentinel) {

      var rect = sentinel.getBoundingClientRect();

      /*
        Sentinel goes above viewport
        => sticky element is currently stuck
      */
      if (rect.top === 0) {
        anyStickyActive = true;
      }

    });

    if (anyStickyActive) {
      body.classList.add('has-sticky-active');
    } else {
      body.classList.remove('has-sticky-active');
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(checkStickyState);
      ticking = true;
    }
  }

  window.addEventListener('load', requestTick);
  window.addEventListener('scroll', requestTick);
  window.addEventListener('resize', requestTick);

  // initial check
  checkStickyState();

})();

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var lastScrollTop = 0;
  var lastSelectedRep = '';

  function watchNavigationScroll(e) {
    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  $.expr[":"].contains = $.expr.createPseudo(function(arg) {
    return function( elem ) {
        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
  });

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();

  function getTooltipPlaccement( tooltip, trigger ) {
    if( $(trigger).attr('data-bs-tooltip-placement') ) {
      return $(trigger).attr('data-bs-tooltip-placement');
    }

    return 'top';
  }

  function getTooltipOffset( tooltip, trigger ) {
    if( $(trigger).attr('data-id') === 'HI' ) {
      return [30, -30];
    }

    return [0, 0];
  }

  function filterActiveLetters() {
    $('.glossary-letter').each(function() {
      var letter = $(this);
      var letter_id = letter.attr('id');
      var has_terms = false;

      letter.nextUntil('.glossary-letter').each(function() {
        var glossary_item = $(this);
        
        if( glossary_item.hasClass('filtered') ) {
          has_terms = true;

          return false;
        }
      })

      if( has_terms ) {
        letter.show();

        $('.section-glossary .glossary-letters a[href="#'+ letter_id +'"]').show();
      }
      else {
        letter.hide();

        $('.section-glossary .glossary-letters a[href="#'+ letter_id +'"]').hide();
      }
    });
  }
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('#navigation').on('show.bs.collapse', function() {
          $('body').addClass('nav-on');
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('nav-on');
        });

        $('body').addClass('dom-loaded');

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        $('.section-news-carousel').find('.embla__viewport').each(function() {
          var t = $(this),
              parent = t.closest('section');

          var embla_config = [];

          if( t.attr('data-autoplay-speed') ) {
            embla_config.push( Autoplay({ playOnInit: true, delay: parseInt( t.attr('data-autoplay-speed') ) * 1000 }) );
          }

          var emblaApi = EmblaCarousel(t.get(0), {
            loop: false,
            align: 'start'
          }, embla_config);

          t.data('embla-api', emblaApi);

          if( parent.find('.embla__button--prev').length ) {
            var removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
              emblaApi,
              parent.find('.embla__button--prev').get(0),
              parent.find('.embla__button--next').get(0),
            );

            emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
          }
        });

        $('.section-features-table').find('.embla__viewport').each(function() {
          var t = $(this),
              parent = t.closest('section');

          var embla_config = [];

          if( t.attr('data-autoplay-speed') ) {
            embla_config.push( Autoplay({ playOnInit: true, delay: parseInt( t.attr('data-autoplay-speed') ) * 1000 }) );
          }

          var emblaApi = EmblaCarousel(t.get(0), {
            loop: false,
            align: 'start'
          }, embla_config);

          t.data('embla-api', emblaApi);

          if( parent.find('.embla__button--prev').length ) {
            var removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
              emblaApi,
              parent.find('.embla__button--prev').get(0),
              parent.find('.embla__button--next').get(0),
            );

            emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
          }

          if( parent.find('.embla__dots').length ) {
            var removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
              emblaApi,
              parent.find('.embla__dots').get(0),
            );

            emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
          }
        });

        $(document).on('click', '.reps-dropdown .dropdown-item', function(e) {
          e.preventDefault();

          if( $(this).hasClass('active') ) return;

          var state = $(this).attr('data-state');
          var rep = $(this).attr('data-staff');

          if( rep !== lastSelectedRep ) {
            lastSelectedRep = rep;

            $('.reps-list .rep-item-wrapper:not(#' + rep + ')').collapse('hide');
            $('#' + rep).collapse('show');
          }

          $('.section-representatives-map .map-wrapper path').removeClass('active');
          $('.section-representatives-map .map-wrapper path[data-name="' + state + '"]').addClass('active');

          $(this).addClass('active').closest('li').siblings('li').find('.dropdown-item').removeClass('active');

          $(this).closest('.reps-dropdown').find('.dropdown-toggle').text( $(this).text() );
        });

        $(document).on('click', '.section-representatives-map .map-wrapper path', function(e) {
          e.preventDefault();

          if( $(this).hasClass('active') ) return;

          var state = $(this).attr('data-name');

          $('.reps-dropdown .dropdown-item[data-state="' + state + '"]').click();
        });

        $('.representatives-map path').each(function() {
          if( $(this).attr('data-name') ) {
            $(this).attr('title', $(this).attr('data-name'));

            if( $(this).attr('data-id') === 'HI' ) {
              $(this).attr('data-bs-tooltip-placement', 'right');
            }
          }
        });

        $('.representatives-map path[title]').tooltip({
          'placement': getTooltipPlaccement,
          'offset': getTooltipOffset,
          'trigger': 'hover'
        }).removeAttr('aria-label');

        if( $('.glossary-item').length ) {
          // var mark_instance = new Mark(document.querySelectorAll(".glossary-item"));
          var mark_instance = new Mark(document.querySelectorAll(".glossary-item .glossary-name"));
        }

        $(document).on('click', '.section-glossary .glossary-letters a', function(e) {
          $(this).closest('.container').find('a.active').removeClass('active');
          $(this).addClass('active');
        });

        $(document).on('input', '.glossary-search-form .search-field', function() {
          var t = $(this);
          var keyword = t.val().trim();

          if( keyword.length < 3 ) {
            $('.glossary-item').show().removeClass('filtered');

            $('.glossary-letter').show();

            $('.section-glossary .glossary-letters a').show();

            mark_instance.unmark();
          }
          else {
            $('.glossary-item').hide().removeClass('filtered');

            // $('.glossary-item:contains(' + keyword + ')').each(function() {
            $('.glossary-item .glossary-name:contains(' + keyword + ')').each(function() {
              $(this).closest('.glossary-item').addClass('filtered').show();
            });

            mark_instance.unmark({
              done: function(){
                mark_instance.mark(keyword);
              }
            });

            filterActiveLetters();
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
